module.exports = __webpack_public_path__ + "cl.9768e54171fecd7983f3.svg";


//////////////////
// WEBPACK FOOTER
// E:/proj/news12/zb-n12/scadmin/client/src/assets/fonts/flag-icon-css/flags/1x1/cl.svg
// module id = ../../../../../src/assets/fonts/flag-icon-css/flags/1x1/cl.svg
// module chunks = styles